import {RaikoBaseContainer} from "@moeindal/base-raiko-panel-components";
import VowTransactions from "./detail/VowTransactions";

export default function VowPayments() {
    return (
        <RaikoBaseContainer>
            <VowTransactions/>
        </RaikoBaseContainer>
    )
}